import React from 'react';
import './OurValues.css';
import { images } from '../../assets';

const valuesData = [
  {
    id: "item1",
    title: 'Clear Communication',
    desc: 'We are direct and succinct. We share information efficiently, emphasizing collaboration and productivity. We practice active listening.',
    image: images.officeGirl,
    className: 'item1Info itemInfo',
    classNames:"valueItemDesc item1Desc",
    alt: 'Office Girl'
  },
  {
    id: "item2",
    title: 'Continuous Learning',
    desc: 'We aim to be humble and value learning above all else. We embrace delivering and receiving candid feedback and see every setback as an opportunity to learn.',
    image: images.officeBoy,
    className: 'itemInfo',
    classNames:"valueItemDesc item2Desc",
    alt: 'Office Boy'
  },
  {
    id:"item3",
    title: 'User Focused',
    desc: 'We are deeply focused on solving our customers\' problems with technology. We strive to be the most usable, trusted, and secure platform for digital entrepreneurs.',
    classNames:"valueItemDesc",
    className: 'itemInfo',
  },
  {
    id:"item4",
    title: 'Positive Energy',
    desc: 'We are optimistic about building the future of banking and determined to get there. We look for solutions instead of choosing blame or criticism.',
    classNames:"valueItemDesc",
    className: 'itemInfo',
  },
];

function OurValues() {
  return (
    <div className='ourValues'>
      <div className='ourValuesBox'>
        <div className='ourValuesContent'>
          <div className='valueTitle'>Our Values</div>
          <div className='valueText'>We care about what we’re building and how we build it.</div>
        </div>
        <div className="valuesContainer">
          {valuesData.map((value, index) => (
            <div className="valueItem" id={value.id} key={`valueItem-${index}`}>
              <div className={value.className}>
                <div className='valueItemTitle'>
                  <div>{value.title.split(' ')[0]}</div> 
                  <span className='secondWord'>{value.title.split(' ')[1]}</span>
                </div>
                <div className={value.classNames}>{value.desc}</div>
              </div>
              {value.image && <img src={value.image} alt={value.alt} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OurValues;
